import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
export default function LossePlaatjie({ type = 'fluid', ...rest }) {
    const source = rest === null || rest === void 0 ? void 0 : rest.src;
    if (!(source === null || source === void 0 ? void 0 : source.mediaItemUrl))
        return null;
    if (type === 'svg' || source.mimeType === 'image/svg+xml') {
        return _jsx(LossePlaatjieSvg, { ...rest }, source.mediaItemUrl);
    }
    return _jsx(LossePlaatjieFluixed, { type: type, ...rest }, source.mediaItemUrl);
}
function LossePlaatjieFluixed({ type, placeholder = 'none', blurRadius = '50px', ...rest }) {
    const { mediaItemUrl, mediaDetails, altText = '', blurBase64 } = rest === null || rest === void 0 ? void 0 : rest.src;
    const blurPlaceholder = placeholder === 'blur' && !!blurBase64;
    const sources = [];
    const placeholderRef = useRef(null);
    const imgRef = useRef(null);
    let imgComponent;
    let imgNoscriptComponent;
    let imgPlaceholderComponent = null;
    let sizes = [];
    const style = blurPlaceholder
        ? {
            visibility: 'hidden'
        }
        : undefined;
    const stylePlaceholder = blurPlaceholder
        ? {
            position: 'absolute',
            filter: `blur(${blurRadius})`,
            overflow: 'hidden',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%'
        }
        : undefined;
    function onLoad() {
        if (placeholderRef.current) {
            placeholderRef.current.style.visibility = 'hidden';
            placeholderRef.current.style.position = 'absolute';
            placeholderRef.current.style.display = 'none';
            placeholderRef.current.style.pointerEvents = 'none';
        }
        if (imgRef.current) {
            imgRef.current.style.position = '';
            imgRef.current.style.visibility = 'visible';
        }
    }
    useEffect(() => {
        var _a;
        if ((_a = imgRef === null || imgRef === void 0 ? void 0 : imgRef.current) === null || _a === void 0 ? void 0 : _a.complete) {
            setTimeout(() => {
                onLoad();
            }, 150);
        }
    }, []);
    if (type === 'fluid') {
        const { maxwidth, maxWidth, autoheight = true, ...fluid } = rest;
        const max = maxwidth || maxWidth;
        const width = max || (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.width) || 1920;
        sizes = getFluidSizes(width);
        let height = 'auto';
        if (!autoheight && (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.width) && (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.height)) {
            height = Math.round((width * (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.height)) / (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.width)).toString();
        }
        if (blurPlaceholder) {
            imgPlaceholderComponent = (_jsx("img", { ...rest, "data-role": "placeholder-img", "aria-hidden": true, src: blurBase64, width: width, height: height, alt: "", ref: placeholderRef, style: stylePlaceholder }));
        }
        imgComponent = (_jsx(Image, { loading: "lazy", alt: altText, ...fluid, srcUrl: `${mediaItemUrl}&width=${width}`, width: width, height: height, onLoad: blurPlaceholder ? onLoad : undefined, imgRef: imgRef, style: style }));
        imgNoscriptComponent = (_jsx(Image, { loading: "lazy", alt: altText, ...fluid, srcUrl: `${mediaItemUrl}&width=${width}`, width: width, height: "auto" }));
    }
    else {
        const { ...fixed } = rest;
        const width = (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.width) || 0;
        const height = (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.height) || 0;
        sizes = getFixedSizes(width, height);
        if (blurPlaceholder) {
            imgPlaceholderComponent = (_jsx("img", { ...rest, "data-role": "placeholder-img", "aria-hidden": true, src: blurBase64, width: width, height: height, alt: "", ref: placeholderRef, style: stylePlaceholder }));
        }
        imgComponent = (_jsx(Image, { loading: "lazy", alt: altText, ...fixed, srcUrl: `${mediaItemUrl}&width=${width}&height=${height}`, width: width, height: height, onLoad: blurPlaceholder ? onLoad : undefined, imgRef: imgRef, style: style }));
        imgNoscriptComponent = (_jsx(Image, { loading: "lazy", alt: altText, ...fixed, srcUrl: `${mediaItemUrl}&width=${width}&height=${height}`, width: width, height: height }));
    }
    const [large, medium, small] = sizes;
    sources.push({
        type: 'image/webp',
        media: `(min-width: ${medium.width}.98px)`,
        srcSet: `${mediaItemUrl}&width=${large.width}`,
        width: large.width,
        height: large.height
    });
    sources.push({
        type: 'image/webp',
        media: `(max-width: ${medium.width}px)`,
        srcSet: `${mediaItemUrl}&width=${medium.width}`,
        width: medium.width,
        height: medium.height
    });
    sources.push({
        type: 'image/webp',
        media: `(max-width: ${small.width}px)`,
        srcSet: `${mediaItemUrl}&width=${small.width}`,
        width: small.width,
        height: small.height
    });
    return (_jsxs(_Fragment, { children: [imgPlaceholderComponent, _jsx("picture", { children: _jsxs(_Fragment, { children: [sources.map((source) => (_jsx("source", { ...source }, source.media))), imgComponent] }) }), _jsxs("noscript", { children: [_jsx("style", { dangerouslySetInnerHTML: {
                            __html: `img[data-role="placeholder-img"] {
              display: none;
            }`
                        } }), _jsx("picture", { children: _jsxs(_Fragment, { children: [sources.map((source) => (_jsx("source", { ...source }, source.media))), imgNoscriptComponent] }) })] })] }));
}
function Image({ altText, srcUrl, width, height, onLoad, imgRef, style, ...rest }) {
    return (_jsx("img", { loading: "lazy", alt: altText, ...rest, src: srcUrl, width: width, height: height, onLoad: onLoad, ref: imgRef, style: style }));
}
function LossePlaatjieSvg({ ...rest }) {
    const { mediaItemUrl, mediaDetails, altText = '' } = rest === null || rest === void 0 ? void 0 : rest.src;
    return (_jsx("img", { loading: "lazy", width: (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.width) || 'auto', height: (mediaDetails === null || mediaDetails === void 0 ? void 0 : mediaDetails.height) || 'auto', alt: altText, ...rest, src: `${mediaItemUrl}` }));
}
function getFluidSizes(maxWidth) {
    return [
        { width: maxWidth, height: 'auto' },
        { width: Math.round(maxWidth / 1.5), height: 'auto' },
        { width: Math.round(maxWidth / 2.75), height: 'auto' }
    ];
}
function getFixedSizes(width, height) {
    const widths = getFluidSizes(width);
    const heights = getFluidSizes(height);
    const length = widths.length;
    return Array.from(Array(length).keys()).map((_, i) => ({
        width: widths[i],
        height: heights[i]
    }));
}
export const lossePlaatjieFragment = `
  blurBase64
  mediaItemUrl
  altText
  mimeType
  mediaType
  mediaDetails {
    width
    height
  }
`;
